import script from "./Reject.vue?vue&type=script&setup=true&lang=js"
export * from "./Reject.vue?vue&type=script&setup=true&lang=js"

import "./Reject.vue?vue&type=style&index=0&id=97b482a2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97b482a2"]])

export default __exports__